import { MLSListing } from '@aloft/toolkit-shared';

import MLSDataColumn from './MLSDataColumn';
import MLSDataInfoSection from './MLSDataInfoSection';
import MlsDataValueWithLabel from './MLSDataValueWithLabel';

const MLSPropertyDetails = ({ listingData }: { listingData: MLSListing }) => (
  <MLSDataInfoSection title="Property Details">
    <MLSDataColumn>
      <MlsDataValueWithLabel
        value={listingData.LivingArea?.toLocaleString('en-US')}
        label="Square Feet"
      />
      <MlsDataValueWithLabel value={listingData.Basement?.join(', ')} label="Basement" />
      <MlsDataValueWithLabel value={listingData.StructureType?.join(', ')} label="Structure" />
      <MlsDataValueWithLabel value={listingData.ArchitecturalStyle?.join(', ')} label="Style" />
      <MlsDataValueWithLabel
        value={
          listingData.Stories ??
          listingData.StoriesTotal ??
          listingData.RawMlsStoriesTotal ??
          listingData.Levels ??
          ''
        }
        label="Stories"
      />
      <MlsDataValueWithLabel
        value={listingData.YearBuilt}
        label="Year Built"
        options={{ noCommaInNumber: true }}
      />
      <MlsDataValueWithLabel
        value={listingData.NewConstructionYN ?? false}
        label="New Construction"
      />
      <MlsDataValueWithLabel value={listingData.Roof?.join(', ')} label="Roof" />
      {/* <MlsDataValueWithLabel value={listingData.???} label="Foundation" /> */}
    </MLSDataColumn>
    <MLSDataColumn>
      <MlsDataValueWithLabel value={listingData.BedroomsTotal} label="Bedrooms" />
      <MlsDataValueWithLabel value={listingData.BathroomsFull} label="Full Baths" />
      <MlsDataValueWithLabel value={listingData.BathroomsThreeQuarter} label="3/4 Baths" />
      <MlsDataValueWithLabel value={listingData.BathroomsHalf} label="1/2 Baths" />
      <MlsDataValueWithLabel value={listingData.FireplacesTotal} label="Fireplaces" />
      <MlsDataValueWithLabel
        value={listingData.FireplaceFeatures?.join(', ')}
        label="Fireplace Description"
      />
      <MlsDataValueWithLabel value={listingData.ParkingFeatures?.join(', ')} label="Parking" />
      <MlsDataValueWithLabel value={listingData.ParkingTotal} label="Total Parking Spaces" />
      <MlsDataValueWithLabel value={listingData.GarageYN} label="Has Garage" />
      {listingData.GarageYN && (
        <MlsDataValueWithLabel value={listingData.GarageSpaces} label="Garage Spaces" />
      )}
    </MLSDataColumn>
  </MLSDataInfoSection>
);

export default MLSPropertyDetails;
